import { createReducer } from '@reduxjs/toolkit';
import { systemSettingApi } from 'services/company/systemSetting';

const initialState = {
  campaign_notification: null,
}

const campaignNotificationReducer = createReducer(initialState, (builder) => {
  builder
    .addMatcher(systemSettingApi.endpoints.getCampaignNotification.matchFulfilled, (state, action) => {
      state.campaign_notification = action.payload.system_setting;
    })
})

export default campaignNotificationReducer;
